define('drops/documentView/documentView',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/imageSize',
    'lq'
], function ($, Drop, Style, util, imageSize, lq) {
    'use strict';

    // NOTE THIS IS NOT FINAL CODE, THIS DROP NEEDS TO BE REMOVED LATER ON
    // BE CAREFUL: UGLY CODE!!
    function DocumentView(options) {
        Drop.call(this, $('<div/>'), options);

        var self = this;
        
        self.$element
            .css({
                whiteSpace: 'pre-wrap'
            });
        
        Style.renderStyles(self);

        self.$element
            .height(self.data.size.y)
            .width(self.data.size.x);
      
        self.$a = $('<a/>')
            .css({
                display: 'inline-block'
            })
            .height(self.data.size.y)
            .width(self.data.size.x)
            .appendTo(self.$element);

        self.$span = $('<span/>')
                    .css({
                        height: self.data.size.y + 'px'
                    })
            .appendTo(self.$a);
        
        self.$img = $('<img/>')
            .css({
                verticalAlign: 'middle'
            })
            .height(self.data.iconSize)
            .width(self.data.iconSize)
            .appendTo(self.$span);

        if (self.data.downloadText) {
            self.$spanDownloadText = $('<span/>')
                .css({
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    paddingLeft: '4px'
                })
                .text(self.data.downloadText)
                .appendTo(self.$span);
        }

        if (!self.data.showIcon) {
            self.$img.hide();
            
            if (self.data.downloadText) {
            	self.$spanDownloadText
					.css({
						paddingLeft: '0px'
					});
            }
        }
        self.hide();
       
        return self;
    };

    Drop.extend(DocumentView, Drop);

    DocumentView.typeName = 'DocumentView';

    DocumentView.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };
	
	DocumentView.prototype.clearValue = function () {
        // todo : don't know what to clear here
    };

    DocumentView.prototype.setValue = function(value) {
        var values = util.convertListOfKeyValuesToObject(value.value);
        var self = this;
        
        if (!values) {
            return;
        }
        var url = values.url || values.Url;
        var filename = values.filename || values.Filename;
        
        if (url.length !== 0) {
            self.$a.show();
            
            //prevents clickthrough on listitems
            self.$a.on('click', function(event) {
                if (event.stopPropagation) { // W3C/addEventListener()
                    event.stopPropagation();
                } else { // Older IE.
                    event.cancelBubble = true;
                }
            });

            self.$a.attr('href', lq.getTenantUrl('DynamicContent/File/' + url + '?filename=' + filename));

            if (self.data.behaviour === "newTab") {
                self.$a.attr('target', '_blank');
            }
            if (self.data.behaviour === "download") {
                self.$a.attr('href', lq.getTenantUrl('DynamicContent/DownloadFile?url=' + url + '&filename=' + filename));
            }

            var requiredSize = imageSize.forElement(self.data.size);
            var src = lq.getTenantUrl('DynamicContent/Thumbnail/' + url + "?width=" + requiredSize.x + "&height=" + requiredSize.y + "&filetype=png&isMaxSize=true");
            self.$img.attr('src', src);

        } else {
            self.$a.hide();
        }
        self.show();
    };
    
    return DocumentView;
});
